module.exports = "dist/images/block-icon-blocks-img1.ec46a6c.png";